export enum AutoMergeOption {
  Manual = 'manual',
  Newest = 'keep_newest',
  Oldest = 'keep_oldest',
}
